<template>
    <div class="el-select athub-dropdown-search" v-clickoutside="handleClose">
        <div class="el-select">
            <div
                class="el-select__tags"
                v-if="multiple"
                ref="tags"
                :style="{ 'max-width': inputWidth - 32 + 'px', width: '100%' }">
                <span v-if="collapseTags && selected.length">
                  <el-tag
                    :closable="!selectDisabled"
                    :size="collapseTagSize"
                    :hit="selected[0].hitState"
                    type="info"
                    @close="deleteTag($event, selected[0])"
                    disable-transitions>
                    <span class="el-select__tags-text">{{ selected[0].currentLabel }}</span>
                  </el-tag>
                  <el-tag
                    v-if="selected.length > 1"
                    :closable="false"
                    :size="collapseTagSize"
                    type="info"
                    disable-transitions>
                    <span class="el-select__tags-text">+ {{ selected.length - 1 }}</span>
                  </el-tag>
                </span>
                <transition-group v-if="!collapseTags">
                  <el-tag
                    v-for="item in selected"
                    :key="getValueKey(item)"
                    :closable="!selectDisabled"
                    :size="collapseTagSize"
                    :hit="item.hitState"
                    type="info"
                    @close="deleteTag($event, item)"
                    disable-transitions>
                    <span class="el-select__tags-text">{{ item.currentLabel }}</span>
                  </el-tag>
                </transition-group>
            </div>
            <el-input
                ref="reference"
                v-model="selectedLabel"
                type="text"
                :placeholder="currentPlaceholder"
                :name="name"
                :id="id"
                :size="selectSize"
                :disabled="selectDisabled"
                :readonly="readonly"
                :validate-event="false"
                :class="{ 'is-focus': visible }"
                >
            </el-input>
            <transition
                name="el-zoom-in-top"
                @after-leave="doDestroy">
            </transition>
        </div>
        <el-popover placement="bottom" :width="formWidth" trigger="click">
            <slot></slot>
            <el-button slot="reference" :size="selectSize" icon="el-icon-arrow-down"></el-button>
        </el-popover>
        <div class="athub-dropdown-buttonGroup" style="display:inline-block">

            <el-button :size="selectSize" @click.native="thisClearHandler"  icon="el-icon-close"></el-button>
            <el-button :size="selectSize" @click.native="thisSubmitHandler" icon="el-icon-search"></el-button>
        </div>
    </div>
</template>

<script type="text/babel">

import { Observable, Subject  } from 'rxjs'
import { map,mapTo,catchError,debounceTime,distinctUntilChanged } from 'rxjs/operators';

import _ from 'lodash'

import ElInput from 'element-ui/packages/input';
import ElTag from 'element-ui/packages/tag';
import Clickoutside from 'element-ui/src/utils/clickoutside';
import { t } from 'element-ui/src/locale';

export default {
    name: 'AthubDropDownSearch',
    componentName: 'AthubDropDownSearch',
    provide() {
      return {
        'select': this
      };
    },
    computed: {
      selectSize() {
        return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
      },
      selectDisabled() {
        return this.disabled || (this.elForm || {}).disabled;
      },
      readonly() {
        return !this.filterable || this.multiple || (!isIE() && !isEdge() && !this.visible);
      },

      collapseTagSize() {
        return ['small', 'mini'].indexOf(this.selectSize) > -1
          ? 'mini'
          : 'small';
      }
    },
    components: {
      ElInput,
      ElTag
    },
    directives: { Clickoutside },
    model: {
        prop: 'model',
        event: 'change'
    },
    props: {
        name: String,
        id: String,
        value: {
          //required: true
        },
        automaticDropdown: Boolean,
        size: String,
        formWidth:{
            type: Number,
            default : 600
        },
        disabled: Boolean,
        clearable: Boolean,
        filterable: Boolean,
        allowCreate: Boolean,
        popperClass: String,
        remote: Boolean,
        multiple: Boolean,
        multipleLimit: {
          type: Number,
          default: 0
        },
        placeholder: {
            type: String,
            default() {
              return t('el.select.placeholder');
            }
        },
        valueKey: {
          type: String,
          default: 'value'
        },
        collapseTags: Boolean,
        clearHandler  : Function,
        submitHandler : Function,

        //athub
        model: Object,
    },
    data() {
        return {
            selected: this.multiple ? [] : {},
            inputLength: 20,
            inputWidth: 0,
            initialInputHeight: 0,
            cachedPlaceHolder: '',
            visible: false,
            selectedLabel: '',
            hoverIndex: -1,
            inputHovering: false,
            currentPlaceholder: '',

            //athub
            labels:[],
            searchFormDataRXObserver : new Subject(),
            dataForm : Object,
            dataFormExpression : String,
        };
    },
    watch: {

        model:{
            handler: function(newValue, oldValue) {
                const me = this;

                me.searchFormDataRXObserver.next( newValue );
            },
            deep: true
        },

        placeholder(val) {
            this.cachedPlaceHolder = this.currentPlaceholder = val;
        },
    },
    methods: {
        doDestroy() {
            this.$refs.popper && this.$refs.popper.doDestroy();
        },
        handleClose() {
            this.visible = false;
        },
        thisClearHandler(){
            const me = this;

            let oldData = $.extend( true, {}, me.model );

            if( me.clearHandler ){
                me.clearHandler();
            }else{
                /*
                if( me.dataForm ){
                    me.dataForm.resetFields();
                }else{
                }
                */
                for( let i in me.labels ){
                    if( me.labels[i] ){
                        let labelSetting = me.labels[i];

                        if( labelSetting.modelExpression ){

                            let valuePath = "me.model." + labelSetting.modelExpression;
                            try{
	                             eval( valuePath + " = null ");
                            }catch( error ){
                                console.log( error );
                            }
                        }
                    }
                }
            }
            me.$emit( 'formDataClear', oldData );
        },
        thisSubmitHandler(){

            const me = this;

            let formData = $.extend( true, {}, me.model );
            if( me.submitHandler ){
                me.submitHandler();
            }
            me.$emit( 'formDataSubmit', formData );
        },
        deleteTag(event, tag) {

            if( this.$refs.thisDropDown && this.$refs.thisDropDown.show && this.$refs.thisDropDown.visible ){
                this.$refs.thisDropDown.show();
            }

            const me = this;

            let index = me.selected.indexOf(tag);
            me.selected.splice( index, 1 );

            let valuePath = tag.modelPath;
            try{
                if( valuePath ){
                    eval( "me.model." +  valuePath + "=null" );
                }
            }catch( error ){
                console.log( error );
            }

            event.stopPropagation();
        },

        refreshFormInfo(){

            const me = this;

            let slots = me.$slots.default;

            let formComponents = [];
            for( let i in slots ){
                formComponents = formComponents.concat( me.getChildren ( slots[i] , "el-form" ) );
            }

            if( formComponents && formComponents.length > 0 ){

                me.dataForm = formComponents[0];

                me.dataFormExpression =
                       _.get( me, "dataForm.$vnode.data.model.expression"   )
                    || _.get( me, "$vnode.data.model.expression"            )
                    || _.get( me, "dataForm.$el.attributes.modelPath.value" )
                    || _.get( me, "$el.attributes.modelPath.value"          )
                    ;
            }
        },
        refreshLabels(){
            const me = this;

            let slots = me.$slots.default;

            if( slots != null && slots.length >= 0 ){

                me.labels = [];
                let formItemComponents = [];
                for( let i in slots ){

                    formItemComponents = formItemComponents.concat( me.getChildren ( slots[i] , "el-form-item" )  );
                    // debugger;
                }


                for( let i in formItemComponents ){
                    let formItemComponent = formItemComponents[i];

                    formItemComponent.$el.attributes.selectedLabel

                    if( formItemComponent ){

                        let newLable = { "text":"-", "mappedValue":null, "modelExpression":null };

                        newLable.text =
                            _.get( formItemComponent, "$el.attributes.selectedLabel" )
                            || _.get( formItemComponent, "$options.propsData.label" )

                        me.labels.push( newLable );

                        let childrenModelExpressions = me.getChildrenModelExpressionsInSlots( formItemComponent );

                        if( childrenModelExpressions && childrenModelExpressions.length > 0 ){
                            newLable.modelExpression = childrenModelExpressions[0];
                        }
                    }
                }
            }
        },
        getChildren( vueComponent , childrenClassName ){
            const me = this;

            let childrenComponents = [];

            let instance = vueComponent.componentInstance || vueComponent;
            if( instance ){
                 if( instance.$el && childrenClassName == instance.$el.className ){
                    childrenComponents.push( instance );
                 }
                 if( instance.$children && instance.$children.length > 0 ){
                    for( let i in instance.$children ){
                        let child = instance.$children[i];
                        if( child.$el && childrenClassName == child.$el.className ){
                            childrenComponents.push( child );
                            continue;
                        }
                        childrenComponents = childrenComponents.concat( me.getChildren ( instance.$children[i], childrenClassName ) );
                    }
                }
            }

            return childrenComponents;
        },
        getChildrenModelExpressionsInSlots( vueComponent ){

            const me = this;

            let childrenModelExpressions = [];

            if( vueComponent.$slots && vueComponent.$slots.default && vueComponent.$slots.default.length > 0 ){

                for( let i in vueComponent.$slots.default ){
                    let slot = vueComponent.$slots.default[i];

                    if( slot ){
                        let expression = _.get( slot, "data.model.expression" ) || _.get( slot, "data.attrs.modelPath" );

                        let pendingRemovePrfix = "."
                        if( me.dataFormExpression ){
                            pendingRemovePrfix = me.dataFormExpression + ".";
                        }
                        if( expression ){
                            expression = expression.substring( expression.indexOf( pendingRemovePrfix ) + pendingRemovePrfix.length , expression.length );
                            childrenModelExpressions.push ( expression );
                        }
                    }
                    if( slot.componentInstance ){
                        childrenModelExpressions = childrenModelExpressions.concat( me.getChildrenModelExpressionsInSlots( slot.componentInstance ) );
                    }
                }
            }

            return childrenModelExpressions;
        }
    },

    mounted: function () {

        const me = this;

        me.refreshFormInfo();
        me.refreshLabels();


        me.searchFormDataRXObserver.pipe(
            map(
                ( e ) => {
                    return e;
                }
            ),
            debounceTime( 200 )
        ).subscribe(
            ( data ) => {

                let formValue = JSON.parse( JSON.stringify( me.model ) );

                if( formValue ){
                    me.selected = [];

                    for( let i in me.labels ){
                        if( me.labels[i] ){
                            let labelSetting = me.labels[i];

                            if( labelSetting.modelExpression ){

                                let valuePath = "formValue." + labelSetting.modelExpression;
                                let value = null;
                                try{
	                                  eval( "value = " + valuePath );
                                }catch( error ){
                                    console.log( error );
                                }

                                if( _.isNumber(value) || !_.isEmpty(value) || _.isBoolean(value)){
                                    me.selected.push( { "currentLabel":labelSetting.text , "modelPath":labelSetting.modelExpression } );
                                }
                            }
                        }
                    }
                }
            }
        );
    },
};
</script>

<style scoped>

/deep/ .el-input__inner{
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
    position: relative;
    top: 1px;
}

.athub-dropdown-search {

}

.athub-dropdown-search /deep/ .el-button{

    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;

    border-left-color : rgba(255,255,255, 0.5);

    margin-left : 0px;

    line-height: 0;
}

.athub-dropdown-search .athub-dropdown-buttonGroup /deep/ .el-button:nth-last-of-type(1){

    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
}



</style>
